export default {
    common: {
        appName: 'Swift Invoice',
        cancel: '取消',
        email: '邮箱',
        password: '密码',
        or: '或',
        change: '更换',
        delete: '删除',
        save: '保存',
        edit: '编辑',
        add: '添加',
        close: '关闭',
        date: '日期',
        total: '总计',
        status: '状态',
        amount: '金额',
        quantity: '数量',
        rate: '费率',
        tax: '税',
        discount: '折扣',
        note: '备注',
        notes: '备注',
        description: '描述',
        client: '客户',
        item: '商品',
        items: '商品',
        type: '类型',
        category: '类别',
        phone: '电话',
        name: '名称',
        subject: '主题',
        saveAndClose: '保存并关闭',
        saveAndSendEmail: '保存并发送邮件',
        sendEmail: '发送邮件',
        send: '发送',
        print: '打印',
        moreActions: '更多操作',
        preparingPdf: '正在准备 PDF...',
        pdfPreparationFailed: '无法生成 PDF',
        warning: '警告',
        ok: '确定',
        uploadSuccess: '上传成功',
        saveSuccess: '保存成功',
        deleteSuccess: '删除成功',
        deleteFailed: '删除失败',
        saveFailed: '保存失败',
        loadFailed: '加载失败',
        systemError: '系统错误',
        sendSuccess: '发送成功',
        updateSuccess: '更新成功',
        unsavedChangesMsg: '您有未保存的更改。要保存还是放弃?',
        saveChangesTitle: '保存更改?',
        confirmSave: '保存',
        discard: '放弃',
        validEmail: '请输入有效的邮箱地址',
        deleteFailedMsg: '删除失败',
        shipping: '运费',
        attachment: '附件',
        days: '天',
        excl: '(不含税)',
        incl: '(含税)',
        of: '的'
    },
    login: {
        heroPrefix: '智能 ',
        heroInvoicing: '开票',
        heroMiddle: ',',
        heroSimplified: '简化',
        heroSuffix: '为您而设。',
        subtitle1: '轻松创建、发送和管理发票。',
        subtitle2: '使用 Swift Invoice 更快收款。',
        feature1Title: '专业发票',
        feature1Text: '几分钟内创建精美发票',
        feature2Title: '实时追踪',
        feature2Text: '追踪付款和发票状态',
        feature3Title: '安全可靠',
        feature3Text: '企业级安全保障您的数据',
        welcomeBack: '欢迎回来',
        signInToContinue: '登录您的账户以继续',
        enterEmail: '请输入邮箱',
        enterPassword: '请输入密码',
        rememberMe: '记住我',
        forgotPassword: '忘记密码?',
        signIn: '登录',
        signingIn: '登录中…',
        continueWithGoogle: '使用 Google 继续',
        continueWithApple: '使用 Apple 继续',
        createAccount: '创建账户',
        startUsing: '开始使用 Swift Invoice',
        companyName: '公司名称',
        enterCompanyName: '请输入公司名称',
        alreadyHaveAccount: '已有账户? 登录',
        footerRights: '© 2026 Swift Invoice. 保留所有权利。',
        termsOfService: '服务条款',
        contactUs: '联系我们: goodinvoicego@gmail.com',
        betaDialogBody: '我们的团队完成了网页的第一版 <br> 此版本仅向 iPhone 用户开放 <br> 我们会尽快完善网页功能并向所有人开放 <br>',
        ieDialogBody: '抱歉,由于 IE 浏览器存在兼容性问题,我们目前不支持 IE 浏览器,如需使用,请下载',
        resetPasswordTitle: '重置密码',
        sendResetEmail: '发送重置邮件',
        resetEmailSent: '重置密码邮件已发送,请检查您的收件箱。',
        bindingTitle: '关联已有账户',
        bindingHintPrefix: '已有账户使用了邮箱 ',
        bindingHintSuffix: '。请输入该账户的密码以关联您的 Google 登录。',
        enterAccountPassword: '请输入账户密码',
        linkAccount: '关联账户',
        validEmail: '请输入有效的邮箱地址',
        validPassword: '密码至少 6 个字符',
        validCompanyName: '请填写公司名称'
    },
    account: {
        title: '账户',
        profile: '个人资料',
        swiftAccount: 'Swift Invoice 账户',
        connectSocial: '关联社交账户',
        companyLogo: '公司 Logo',
        addLogo: '添加 Logo',
        uploading: '上传中...',
        currentPlan: '当前套餐: Swift {plan}',
        planActiveUntil: '套餐有效期至 {date}',
        sharedWithMobile: '与移动端共享',
        subscriptionExpired: '您的订阅已过期',
        planNote: '如果您的订阅状态未更新,请重新登录。',
        upgradeToPro: '升级到 Swift Pro',
        viewPlans: '查看订阅套餐',
        connecting: '关联中…',
        connectGoogle: '关联 Google',
        googleConnected: 'Google 已关联',
        googleConnectedWithEmail: 'Google 已关联 ({email})',
        connectApple: '关联 Apple',
        appleConnected: 'Apple 已关联',
        appleConnectedWithEmail: 'Apple 已关联 ({email})',
        logoUuidMissing: '缺少公司 Logo UUID',
        googleConnectedToast: 'Google 账户已关联。',
        appleConnectedToast: 'Apple 账户已关联。'
    },
    menu: {
        invoices: '发票',
        estimates: '报价单',
        purchaseOrders: '采购订单',
        items: '商品',
        clients: '客户',
        expenses: '支出',
        reports: '报表',
        settings: '设置',
        companyInfo: '公司信息',
        taxes: '税务',
        default: '默认',
        customizeInvoice: '自定义发票',
        sendFeedback: '发送反馈',
        newReply: '1 条新回复',
        signOut: '退出登录',
        signOutConfirm: '确定要退出登录吗?',
        addBusiness: '添加公司',
        newBusinessTitle: '新建公司',
        businessName: '公司名称',
        businessNamePlaceholder: '请输入公司名称',
        createBusiness: '创建',
        businessNameRequired: '请输入公司名称',
        createBusinessSuccess: '公司创建成功'
    },
    network: {
        loginExpired: '登录已过期,请重新登录',
        requestTimeout: '请求超时,请检查网络'
    },
    language: {
        label: '语言',
        zh: '中文',
        en: 'English'
    },
    invoice: {
        searchPlaceholder: '搜索您的发票',
        addInvoice: '添加发票',
        overdueInvoices: '逾期发票',
        paidInvoices: '已付发票',
        unpaidInvoices: '未付发票',
        unsentInvoices: '未发送发票',
        columnNumber: '编号',
        columnClient: '客户',
        columnStatus: '状态',
        statusFullyPaid: '已全付',
        statusPartial: '部分付款',
        statusOverdue: '逾期',
        statusUnsent: '未发送',
        statusSent: '已发送',
        statusOpened: '已打开',
        actionRecordPayment: '记录付款',
        actionMarkAsSent: '标记为已发送',
        actionCopy: '复制',
        actionDelete: '删除',
        copyDialogTitle: '复制发票',
        copyTargetType: '复制为',
        copyOptions: '复制选项',
        copyClient: '复制客户',
        copyItems: '复制商品',
        copyAttachments: '复制附件',
        confirmDelete: '将删除此发票，是否继续？',
        copySuccess: '发票已复制',
        copyFailed: '复制失败',
        deleteSuccess: '发票已删除',
        deleteFailed: '删除失败',
        recordPaymentDialogTitle: '记录付款',
        markAsFullyPaid: '标记为已全付',
        formAmount: '金额',
        formDate: '日期',
        formPaymentMethod: '付款方式',
        formNote: '备注',
        allYears: '所有年份',
        errorMorePaymentThanBalanceDue: '付款金额超过应付余额',
        errorAmountMustBeGreaterThanZero: '金额必须大于零',
        dueDateToday: '今天',
        dueDateDaysAgo: '{days} 天前',
        dueDateInDays: '{days} 天内'
    },
    estimate: {
        pageTitlePurchaseOrders: '采购订单',
        pageTitleEstimates: '报价单',
        searchPlaceholderPurchaseOrders: '搜索您的采购订单',
        searchPlaceholderEstimates: '搜索您的报价单',
        addPurchaseOrder: '添加采购订单',
        addEstimate: '添加报价单',
        columnNumber: '编号',
        columnClient: '客户',
        columnDate: '日期',
        columnEmail: '邮箱',
        columnStatus: '状态',
        columnTotal: '总计',
        statusUnsent: '未发送',
        statusSent: '已发送',
        actionMarkAsSent: '标记为已发送',
        actionCopy: '复制',
        actionDelete: '删除',
        actionConvertToInvoice: '转为发票',
        copyDialogTitle: '复制{document}',
        copyTargetType: '复制为',
        copyOptions: '复制选项',
        copyClient: '复制客户',
        copyItems: '复制商品',
        copyAttachments: '复制附件',
        confirmDelete: '将删除此{document}，是否继续？',
        convertConfirm: '将此{document}转为发票？日期将改为今天。',
        copySuccess: '{document}已复制',
        copyFailed: '复制失败',
        convertSuccess: '{document}已转为发票',
        convertFailed: '转换失败',
        deleteSuccess: '{document}已删除',
        deleteFailed: '删除失败',
        dueDateToday: '今天',
        dueDateDaysAgo: '{days} 天前',
        dueDateInDays: '{days} 天内'
    },
    item: {
        pageTitle: '商品',
        searchPlaceholder: '搜索您的商品',
        addItem: '添加商品',
        columnInventoryCountUnit: '库存数量/单位'
    },
    client: {
        pageTitle: '客户',
        searchPlaceholder: '搜索您的客户',
        addClient: '添加客户',
        columnClientName: '客户名称',
        columnEmail: '邮箱',
        columnPhone: '电话',
        columnBalanceDue: '应付余额',
        noNameFallback: '未命名'
    },
    expense: {
        pageTitle: '支出',
        searchPlaceholder: '搜索您的支出',
        addExpense: '添加支出',
        columnDescription: '描述',
        columnDate: '日期',
        columnTotal: '总计'
    },
    report: {
        headerTitle: '报表',
        tabDashboard: '仪表盘',
        tabReportList: '报表列表',
        export: '导出',
        annualSalesByClient: '客户年度销售额',
        totalOutstandingBalance: '未结余额总计',
        invoicesCountSuffix: '张发票',
        byMonth: '按月',
        byQuarter: '按季',
        noSalesFound: '未找到销售记录',
        filterReportTypes: '报表类型',
        filterTimePeriod: '时间段',
        filterView: '视图',
        optionMonthly: '月度',
        optionQuarterly: '季度',
        customerAgingTitle: '客户账龄',
        noDataForDateRange: '此日期范围内无数据',
        typeSalesByDate: '按日期销售',
        typeSalesByClient: '按客户销售',
        typeSalesByItem: '按商品销售',
        typeSalesJournal: '销售日记账',
        typePaymentsByDate: '按日期付款',
        typePaymentsByClient: '按客户付款',
        typePaymentsByType: '按类型付款',
        typePaymentsJournal: '付款日记账',
        typeExpenseByCategory: '按类别支出',
        typeExpenseJournal: '支出日记账',
        typeCustomerAging: '客户账龄',
        allYears: '所有年份',
        allTime: '全部时间',
        allSales: '所有销售',
        taxYearSales: '税务年度 {year} 销售',
        firstColumnMonth: '月份',
        firstColumnQuarter: '季度',
        columnSubTotal: '小计',
        columnTax: '税',
        columnDiscount: '折扣',
        columnTotal: '总计',
        columnAmountPaid: '已付金额',
        columnAmountOwed: '欠款金额',
        columnClient: '客户',
        columnItem: '商品',
        columnUnitType: '单位类型',
        columnQuantity: '数量',
        columnRateAvg: '费率(均值)',
        columnInvoiceDate: '发票日期',
        columnInvoiceNo: '发票号',
        columnType: '类型',
        columnPaymentDate: '付款日期',
        columnCategory: '类别',
        columnExpenseDate: '支出日期',
        columnMerchant: '商户',
        columnDescription: '描述',
        columnCurrentDue: '当前应付',
        column1To30DaysOverdue: '逾期 1-30 天',
        column31To60DaysOverdue: '逾期 31-60 天',
        column61To90DaysOverdue: '逾期 61-90 天',
        column91PlusDaysOverdue: '逾期 91+ 天',
        monthNames: '1月, 2月, 3月, 4月, 5月, 6月, 7月, 8月, 9月, 10月, 11月, 12月',
        totalRowLabel: '总计'
    },
    invoiceCreate: {
        pageTitlePrefix: '添加',
        invoicePrefix: '发票前缀',
        tabCreate: '创建',
        tabPreview: '预览',
        tabSendEmail: '发送邮件',
        sectionClient: '客户',
        addClient: '添加客户',
        dialogClientInfo: '客户信息',
        basicInformation: '基本信息',
        labelName: '名称',
        labelEmail: '邮箱',
        labelPhone: '电话',
        billingAddress: '账单地址',
        labelLine1: '行 1',
        labelLine2: '行 2',
        labelLine3: '行 3',
        shippingAddress: '收货地址',
        labelShippingName: '收货人姓名',
        labelNotes: '备注',
        placeholderCreateOrSelect: '创建或选择一个...',
        placeholderClientNotes: "添加客户备注。他们看不到这些内容",
        sectionItems: '商品',
        saveToYourItem: '保存到您的商品',
        stock: '库存:',
        placeholderItemCode: '商品编码',
        placeholderQuantity: '数量',
        placeholderRate: '费率',
        placeholderInputDescription: '输入描述',
        placeholderInputComment: '输入评论',
        placeholderAddRecipient: '添加收件人',
        cc: '抄送',
        bcc: '密送',
        placeholderEmailSubject: '邮件主题',
        placeholderMessage: '撰写您的消息...',
        labelTo: '收件人',
        labelSubject: '主题',
        sectionAttachments: '附件',
        sectionComment: '评论',
        addItem: '添加商品',
        addPhoto: '添加照片',
        addPayment: '添加付款',
        goBack: '返回',
        dialogShippingInfo: '运输信息',
        dialogRecordPayment: '记录付款',
        dialogJobDetails: '工作详情',
        labelAmount: '金额',
        labelShipDate: '发货日期',
        labelShipVia: '运输方式',
        labelTrackingNumber: '追踪号',
        labelFob: 'FOB',
        columnDate: '日期',
        columnType: '类型',
        msgClientEmailError: '客户邮箱错误',
        msgAmountGreaterThanZero: '金额必须大于零',
        msgMorePaymentThanBalance: '付款金额超过应付余额',
        mailSentSuccessfully: '邮件发送成功',
        cumulativeTaxNotice: '网页版不支持发票中的累计税...',
        numberLogicNotice: '我们最近更改了编号逻辑。如果编号不正确，请在此处编辑。您也可以前往“设置 > 自定义发票 > 下一个编号”，将“编号起始值”设置为您需要的编号。',
        confirmUnsavedChanges: '您有未保存的更改。要保存还是放弃?',
        pdf: 'PDF',
        taxDiscountWithholding: '税、折扣和预扣',
        purchaseOrder: '采购订单',
        placeholderPurchaseOrderPrefix: '采购订单前缀',
        placeholderEstimatePrefix: '报价单前缀',
        labelStatus: '状态',
        statusIssued: '已开具',
        statusApproved: '已批准',
        statusPending: '待处理',
        statusWithdrawn: '已撤回',
        tax: '税'
    },
    createEstimate: {
        pageTitlePrefix: '添加',
        cumulativeTaxNotice: '网页版不支持报价单中的累计税...'
    },
    updateInvoice: {
        pageTitlePrefix: '编辑',
        deletePrefix: '删除',
        confirmDelete: '将删除此发票。继续?',
        cumulativeTaxNotice: '此发票包含累计税。网页版暂不支持此功能'
    },
    updateEstimate: {
        pageTitlePrefix: '编辑',
        deletePrefix: '删除',
        confirmDelete: '将删除此{document}。继续?',
        cumulativeTaxNotice: '此报价单包含累计税。网页版暂不支持此功能'
    },
    createAccount: {
        title: '创建账户',
        placeholderEmail: '邮箱',
        placeholderPassword: '密码',
        placeholderCompanyName: '公司名称',
        createAccountButton: '创建账户',
        alreadyHaveAccount: '已有账户?',
        signIn: '登录',
        validEmail: '请输入有效的邮箱地址',
        validPassword: '密码至少 6 个字符',
        validCompanyName: '请填写公司名称'
    },
    clientCreate: {
        pageTitle: '添加客户',
        basicInformation: '基本信息',
        labelName: '名称',
        placeholderName: '输入名称...',
        labelEmail: '邮箱',
        placeholderEmail: '输入邮箱地址...',
        labelPhone: '电话',
        placeholderPhone: '输入电话号码...',
        billingAddress: '账单地址',
        labelLine1: '行 1',
        labelLine2: '行 2',
        labelLine3: '行 3',
        shippingAddress: '收货地址',
        sameAsBilling: '与账单地址相同',
        labelShippingName: '收货人姓名',
        labelShippingLine1: '行 1',
        labelShippingLine2: '行 2',
        labelShippingLine3: '行 3',
        labelNotes: '备注',
        placeholderNotes: "添加客户备注。他们看不到这些内容",
        validEmail: '请输入有效的邮箱地址'
    },
    clientUpdate: {
        pageTitle: '编辑客户',
        confirmDelete: '将删除此客户。继续?'
    },
    itemCreate: {
        pageTitle: '添加商品',
        itemTitle: '商品',
        labelCost: '成本',
        labelUnit: '单位',
        placeholderUnit: '单位',
        defaultTaxes: '默认税率',
        taxOff: '关闭',
        inventoryTitle: '库存',
        currentInventory: '当前库存',
        adjustInventory: '调整库存',
        placeholderQuantity: '数量',
        placeholderDateAndTime: '日期和时间',
        placeholderNote: '备注',
        addButton: '添加',
        columnDate: '日期',
        columnQuantity: '数量',
        columnNote: '备注',
        withholdingTitle: '预扣',
        msgInventoryCannotDisable: '库存启用后无法禁用',
        msgDescriptionRequired: '商品描述为必填项',
        msgQuantityRequired: '数量为必填项',
        msgDateRequired: '日期和时间为必填项'
    },
    itemUpdate: {
        pageTitle: '编辑商品',
        columnInvoice: '发票',
        confirmDelete: '将删除此商品。继续?'
    },
    createStatement: {
        pageTitle: '对账单',
        tabPreview: '预览',
        tabSendEmail: '发送邮件'
    },
    setting: {
        taxInfo: '税务信息',
        taxes: '税率',
        taxYearStarts: '税务年度开始',
        taxYearStartSubtitle: '设置财政年度的第一天',
        rateLabel: '税率(%)',
        abbreviation: '缩写',
        addTax: '添加税率',
        month: '月份',
        day: '日期',
        monthPlaceholder: '月份',
        dayPlaceholder: '日期',
        saveTaxYearStart: '保存',
        deleteDialogTitle: '删除',
        confirmDeleteTax: '确定删除此税率吗?',
        deleteConfirm: '删除',
        taxInfoDialogTitle: '税务信息',
        taxName: '税名',
        standardRate: '标准税率 (%)',
        additionalRate: '附加税率',
        deleteRateX: 'X',
        addRate: '添加税率',
        taxType: '税类型',
        exclusive: '不含税',
        inclusive: '含税',
        close: '关闭',
        saveTax: '保存税率',
        cantOpenDetailMessage: '此税率包含累计税。网页版暂不支持此功能',
        closeButton: '关闭',
        rateIsRequired: '税率为必填项',
        rateIsRequiredMsg: '税率为必填项',
        monthAndDayRequired: '月份和日期为必填项',
        moreRate: ' 个附加税率',
        moreRates: ' 个附加税率'
    },
    companyInfo: {
        title: '公司信息',
        details: '详情',
        businessName: '企业名称',
        businessNamePlaceholder: '企业名称',
        name: '名称',
        phone: '电话',
        email: '邮箱',
        businessNumber: '营业执照号',
        taxNo: '税号',
        deleteField: '删除',
        addNewField: '添加新字段',
        address: '地址',
        line1: '行 1',
        line2: '行 2',
        line3: '行 3',
        currency: '货币',
        currencyLabel: '货币',
        symbol: '符号',
        placement: '位置',
        before: '之前',
        after: '之后',
        thousandSymbol: '千分位符号',
        decimalSymbol: '小数符号',
        decimalPlaces: '小数位数',
        example: '示例',
        terms: '条款',
        termsLabel: '条款',
        termSameDay: '当天',
        term7Days: '7 天',
        term14Days: '14 天',
        term21Days: '21 天',
        term30Days: '30 天',
        term45Days: '45 天',
        term60Days: '60 天',
        term90Days: '90 天',
        term180Days: '180 天',
        term365Days: '365 天',
        paymentInfo: '付款信息',
        displayOnInvoices: '在发票上显示',
        titlePlaceholder: '标题',
        jobDetails: '工作详情',
        deleteJobDetail: '删除',
        addNewJobField: '添加新字段'
    },
    default: {
        title: '默认',
        emailMessage: '邮件内容',
        enterDescription: '输入描述',
        emailCc: '邮件抄送',
        emailBcc: '邮件密送',
        emailTip: '同时发送电子邮件至上述地址。',
        defaultComments: '默认评论',
        invoice: '发票',
        estimate: '报价单',
        purchaseOrder: '采购订单',
        creditMemo: '贷项通知单',
        emailValidError: '邮箱有效'
    },
    invoiceDesign: {
        template: '模板',
        color: '颜色',
        labels: '标签',
        labelInvoice: '发票',
        labelEstimate: '报价单',
        labelPurchaseOrder: '采购订单',
        labelCreditMemo: '贷项通知单',
        labelReceipt: '收据',
        labelTermsFormat: '条款格式',
        labelBillTo: '账单至',
        labelFor: '对于',
        labelDate: '日期',
        labelInvoiceNo: '发票号',
        labelEstimateNo: '报价单号',
        labelPoNo: '采购订单号',
        labelCreditMemoNo: '贷项通知单号',
        labelDueDate: '到期日',
        labelTerms: '条款',
        labelAmount: '金额',
        labelCode: '编码',
        labelDescription: '描述',
        labelQuantity: '数量',
        labelRate: '费率',
        labelTax: '税',
        labelSubtotal: '小计',
        labelBalanceDue: '应付余额',
        labelDiscount: '折扣',
        labelNonTaxableItem: '非应税商品',
        labelPaid: '已付',
        labelShipping: '运费',
        labelTotal: '总计',
        labelIncludes: '包含',
        labelTotalAmountPaid: '已付总额',
        labelShipDate: '发货日期',
        labelShipTo: '收货至',
        labelShipVia: '运输方式',
        labelTrackingNo: '追踪号',
        labelFob: 'FOB',
        prefix: '前缀',
        prefixInvoice: '发票',
        prefixEstimate: '报价单',
        prefixPurchaseOrder: '采购订单',
        prefixCreditMemo: '贷项通知单',
        nextNumber: '下一个编号',
        numberingBeginsAt: '编号起始',
        nextNumberInvoice: '发票',
        nextNumberEstimate: '报价单',
        nextNumberPurchaseOrder: '采购订单',
        nextNumberCreditMemo: '贷项通知单',
        options: '选项',
        optionTerms: '条款',
        optionDueDate: '到期日',
        optionShippingAddress: '收货地址',
        optionProductCode: '商品编码',
        optionQuantityAndRate: '数量和费率',
        optionTax: '税',
        optionAmount: '金额',
        optionNonTaxableItemStar: '非应税商品星标',
        optionTaxBreakdown: '税费明细',
        optionPaymentHistory: '付款历史',
        optionStamp: '印章',
        optionPageNumber: '页码',
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewShipName: 'Peter',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewThanksMessage: "感谢您的惠顾!希望您对我们的工作满意。请在 15 天内汇款。有问题?意见?请联系(111)111-1234 或发邮件至 example@owner.com,我们很乐意解答任何问题或疑虑。",
        previewSubtotal: '小计',
        previewVat: 'VAT 17.00%',
        previewPayment1: 'Payment on Oct 1, 2019',
        previewPayment2: 'Payment on Oct 2, 2019'
    },
    feedback: {
        title: '发送反馈',
        invalidEmailNoticePrefix: '您账户上的邮箱地址无效,因此我们无法联系您。请从有效邮箱发送反馈至',
        invalidEmailNoticeSuffix: '如可能,请附上问题截图;这将帮助我们调查和解决。',
        replyTip: '发送后,请检查您的邮箱以获取回复。',
        content: '内容',
        enterDescription: '输入描述'
    },
    createExpense: {
        title: '添加支出',
        description: '描述',
        expenseDescriptionPlaceholder: '支出描述',
        total: '总计',
        tax: '税',
        tip: '小费',
        expenseDate: '支出日期',
        merchant: '商户',
        merchantPlaceholder: '输入商户名称',
        categoryPlaceholder: '选择类别',
        addNewCategory: '添加新类别',
        deletePhoto: '删除',
        addPhoto: '添加照片',
        deleteCategory: '删除',
        addCategory: '添加类别'
    },
    updateExpense: {
        title: '编辑支出',
        deleteExpense: '删除支出',
        confirmDeleteMsg: '将删除此支出。继续?'
    },
    notFound: {
        oops: '哎呀!',
        notFoundMsg: '我们似乎找不到您要的页面。',
        takeMeHome: '返回首页'
    },
    classicPDF: {
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewDueDate: 'Nov 15,2019',
        previewShipName: 'Peter',
        previewFreeShipping: 'Free Shipping',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewItem1: 'Computer',
        previewItem2: 'Phone',
        previewItem3: 'Birthday cake',
        previewTaxRate: '17%',
        nonTaxableNote: '* 表示非应税商品',
        thanksMessage: "感谢您的惠顾!希望您对我们的工作满意。请在 15 天内汇款。有问题?意见?请联系(111)111-1234 或发邮件至 example@owner.com,我们很乐意解答任何问题或疑虑。",
        subtotal: '小计',
        vat: 'VAT 17.00%',
        payment1: 'Payment on Oct 1, 2019',
        payment2: 'Payment on Oct 2, 2019',
        balanceDue: '应付余额'
    }
};
